// src/utils/image.js

const FILE_BASE_URL = "https://bgfiles.aimpointventures.my";
// const FILE_BASE_URL = "https://staging-bgfiles.aimpointventures.my";

export const getImageUrl = (path) => {
  if (!path) return "";

  // Already a full URL
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  // Remove leading slashes
  const normalizedPath = String(path).replace(/^\/+/, "");

  return `${FILE_BASE_URL}/${normalizedPath}`;
};